var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0556 16.4827C23.0556 16.4827 22.8351 18.0306 22.1582 18.7131C21.3008 19.6055 20.3385 19.6111 19.898 19.663C16.742 19.8904 11.9994 19.8977 11.9994 19.8977C11.9994 19.8977 6.13257 19.8447 4.32812 19.6715C3.82667 19.5784 2.69853 19.6055 1.84058 18.7131C1.1637 18.0306 0.943724 16.4827 0.943724 16.4827C0.943724 16.4827 0.717529 14.6653 0.717529 12.8484V11.1448C0.717529 9.3274 0.943724 7.51048 0.943724 7.51048C0.943724 7.51048 1.1637 5.96321 1.84058 5.28122C2.69853 4.38772 3.65968 4.38323 4.10136 4.33131C7.25788 4.1023 11.9949 4.10229 11.9949 4.10229H12.0044C12.0044 4.10229 16.742 4.1023 19.898 4.33131C20.3385 4.3832 21.3008 4.38772 22.1582 5.28122C22.8351 5.96321 23.0556 7.51048 23.0556 7.51048C23.0556 7.51048 23.2824 9.32738 23.2824 11.1448V12.8484C23.2824 14.6653 23.0556 16.4827 23.0556 16.4827ZM9.74349 8.6153L9.7452 14.8206L15.9488 11.7282L9.74349 8.6153Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.875906eb2ba1a3bd2e72f71c907905db.svg";
export { ForwardRef as ReactComponent };